import ImageGrid from '../ImageGrid/ImageGrid';
import SpainHeaderComp from '../Header/SpainHeaderComp'
import Section from '../Section'
import FormStyle1 from '../Form/FormStyle1';
import { Helmet } from 'react-helmet-async';
const FivSpainText = () => {
  return (
    <>
         <Helmet>
           <title>Programas Fiv - Gestlife</title>
           <meta name="description" content="Tratamientos de reproduccion asistida en Gestlife" />
         </Helmet>
   <div style={styles.container}>
      <div style={styles.contentWrapper}>
        {/* Contenido principal a la izquierda */}
        <div style={styles.mainContent}>
          <h1 style={styles.mainHeading}>
            Programas Fiv
          </h1>
 <div style={styles.textBlock}>
            <p style={styles.highlightedParagraph}>
             GESTLIFE te ofrece en distintos países donde realizar tratamientos de reproducción asistida, que no podrías hacer en tu propio país:
            </p>
            
            <ul>
                <li>
                    <p style={styles.paragraph}>
              Con selección de sexo
            </p>
                </li>
                <li>
                <p style={styles.paragraph}>
              Programas ilimitados
            </p>
                </li>
                <li>
                <p style={styles.paragraph}>
        	Trasplante pronuclear ( técnica de los 3 padres).
            </p>
                </li>
            </ul>

          <h2 style={styles.subHeading}>
            Emabrazo garantizado
          </h2>

         
            <p style={styles.paragraph}>
             Usted muy probablemente ha estudiado ya la posibilidad de realizar un programa de reproducción asistida en su país de origen, dónde habitualmente las clínicas le cobran ciclo por ciclo, hasta que logra usted su objetivo: El embarazo.  Si por mala fortuna, no logra usted el embarazo, debe pagar ciclo tras ciclo, hasta lograrlo o abandonar.
            </p>
            <p style={styles.paragraph}>
             En GESTLIFE, estamos de su lado.  Nuestros programas, en colaboración con las más prestigiosas clínicas de Ucrania, Albania o georgia (con las más altas tasas de éxito), le garantizamos el embarazo a un precio cerrado, o le devolvemos el 50 % del coste del tratamiento médico (programas Embarazo Garantizado).  De este modo usted tiene la seguridad de lograr su objetivo, ya que la clínica es la más interesada en lograr su embarazo.
            </p> 
           
           <ol>
            <li>
            <p style={styles.paragraph}>
             <b>CLÍNICAS DE ALTO RANGO:</b> Clínicas de reproducción asistida de primer rango con tasas de éxito de embarazo de las más altas en europea.  GESTLIFE  se ha preocupado de seleccionar las mejores clínicas, y nuestro equipo de inspectores las visita mensualmente, para verificar los estándares de calidad.
            </p>  
            </li>

            <li>
            <p style={styles.paragraph}>
             <b>CICLOS DE FIV ILIMITADOS:</b> por un precio cerrado, usted tiene garantizadas los ciclos de fecundación in vitro que sean necesarios, hasta lograr el objetivo deseado en los programas “EMBARAZO GARANTIZADO”: su embarazo.  Sin costes adicionales, sin sorpresas.  Si no lo logramos le devolvemos el 50 % del coste del tratamiento médico que ha pagado por el programa.
            </p>  
            </li>

            <li>
            <p style={styles.paragraph}>
             <b>AHORRO ECONÓMICO:</b> frente a las clínicas en  su país de origen, ucrania le ofrece unos programas económicamente muy atractivos, con un  importantísimo ahorro de dinero, que compensa amplísimamente el coste de los viajes.
            </p>  
            </li>

             <li>
            <p style={styles.paragraph}>
             <b>SELECCIÓN DE LA DONANTE DE ÓVULOS:</b> en su país de origen usted no puede seleccionar la donante.  Se escoge según el fenotipo que tenga usted (morena, rubia, alta, baja). En Ucrania en algunos programas usted  puede seleccionar la donante entre una base de datos con fotografías de la donante, características, aficiones etc…
            </p>  
            </li>

             <li>
            <p style={styles.paragraph}>
             <b>SELECCIÓN DE SEXO:</b> en su país de origen la selección de sexo no está permitida. En Ucrania sí. Si lo desea puede escoger un programa con selección de sexo.
            </p>  
            </li>

            <li>
            <p style={styles.paragraph}>
             <b>CENTRO DE ASISTENCIA EN SU IDIOMA:</b> usted dispone del servicio de un centro de asistencia en su idioma, con un encargado de asistencia asignado a usted.  Con él podrá organizar, en su propio idioma, todo el proceso.
            </p>  
            </li>

             <li>
            <p style={styles.paragraph}>
             <b>ACOMPAÑAMIENTO IN SITU:</b> un encargado de asistencia,  que habla su idioma, le acompañará en todo momento  desde su llegada al  aeropuerto, visita a la clínica etc… usted no se sentirá extranjero en un país extranjero. En los programas VIP le facilitaremos además un teléfono  móvil local  para sus llamadas, y estar comunicado con su acompañante,  y con la central sin coste para usted.
            </p>  
            </li>

              <li>
            <p style={styles.paragraph}>
             <b>ALOJAMIENTO Y COMIDAS:</b> dentro de las tarifas está incluido el alojamiento en apartamentos individuales de la compañía en el centro de Kiev. En, los programas VIP  además se incluye  el desayuno,  la comida y  la cena durante su estancia en el apartamento.  Los apartamentos están dotados de WI-FI  y de televisión, para los momentos de relax.
            </p>  
            </li>
           </ol>

           <h4 style={styles.subHeadingMinor}>
           Filosofia
            </h4>

              <p style={styles.paragraph}>
             Nuestra filosofía está orientada  hacia la calidad total. Por ese motivo en GESTLIFE  solo seleccionamos las mejores clínicas, que hemos verificado personalmente, y reúnen todos los parámetros de una larga lista de requisitos, enfocados a la máxima calidad. 
            </p> 

                <p style={styles.paragraph}>
             Nuestras clínicas  cuentan con todas las tecnologías reproductivas avanzadas en la práctica mundial:
            </p>  

            <ul>
                <li>
                    <p style={styles.paragraph}>
            	Diagnóstico genético preimplantacional por el método de hibridación genómica comparativa
            </p>
                </li>
                <li>
                <p style={styles.paragraph}>
              	Embryoscope
            </p>
                </li>
                <li>
                <p style={styles.paragraph}>
        	IMSI
            </p>
                </li>
                 <li>
                <p style={styles.paragraph}>
        	Criopreservación de embriones
            </p>
                </li>
                <li>
                <p style={styles.paragraph}>
        	centros de atención prenatal - la observación de embarazo hasta el parto
            </p>
                </li>
                  <li>
                <p style={styles.paragraph}>
        	La única clínica  que devuelve el 50 % del coste del tratamiento médico en los programas EMBARAZO GARANTIZADO por el tratamiento en caso de que no se haya logrado el embarazo.
            </p>
                </li>
            </ul>

             <h4 style={styles.subHeadingMinor}>
           Nuestro compromiso:
            </h4> 
             
             <p style={styles.paragraph}>
            Máxima satisfacción para los pacientes: 
            </p> 
           
           <ul>
            <li>
            <p style={styles.paragraph}>
             La introducción de los últimos avances mundiales en el campo de la medicina reproductiva en nuestra práctica clínica.
            </p>  
            </li>
            <li>
            <p style={styles.paragraph}>
            La creación de métodos avanzados de tratamiento de la infertilidad a través de la pertenencia a asociaciones internacionales de medicina de la reproducción.
            </p>  
            </li>
            <li>
            <p style={styles.paragraph}>
             La garantía de la accesibilidad de los servicios de la clínica a través del desarrollo de programas especiales  para los pacientes y su apoyo psicológico.
            </p>  
            </li>
            </ul>

                <p style={styles.paragraph}>
           La dirección de GESTLIFE ha definido las direcciones principales de la política en el campo de la gestión de la calidad: 
            </p> 
           
           <ul>
            <li>
            <p style={styles.paragraph}>
             Garantía de la atención médica que cumpla con las expectativas de los pacientes, las normas médicas y los requisitos legales.
            </p>  
            </li>
            <li>
            <p style={styles.paragraph}>
            La mejora de la calidad de la atención médica a través del desarrollo, reequipamiento técnico, la mejora de las tecnologías y métodos de tratamiento.
            </p>  
            </li>
            <li>
            <p style={styles.paragraph}>
            Optimización de todos los procesos, para garantizar su eficacia y reducir los costes de todo tipo.
            </p>  
            </li>
            <li>
            <p style={styles.paragraph}>
            Búsqueda constante de la perfección técnica e informativa.
            </p>  
            </li>
             <li>
            <p style={styles.paragraph}>
            La garantía de un enfoque sistemático para la gestión y mejora continua de todos los aspectos de las actividades de gestión para garantizar la calidad de la atención.
            </p>  
            </li>
             <li>
            <p style={styles.paragraph}>
            La contribución de buena reputación entre nuestros pacientes, socios, proveedores de equipos, instrumentos y medicamentos y otras partes interesadas.
            </p>  
            </li>
             <li>
            <p style={styles.paragraph}>
            La mejora de la cualificación de los trabajadores mediante la formación, la participación en seminarios, conferencias, cursos de formación y realizar investigaciones y participar en asociaciones profesionales internacionales.
            </p>  
            </li>
            <li>
            <p style={styles.paragraph}>
            Cada empleado contribuye en el éxito de la clínica, independientemente de la posición que ocupa. Todos entendemos el valor y el significado de cada uno
            </p>  
            </li>
            <li>
            <p style={styles.paragraph}>
            Todos los empleados prestan la máxima atención a cada paciente, manteniendo la confidencialidad
            </p>  
            </li>
            <li>
            <p style={styles.paragraph}>
            Creación de un ambiente de participación en los resultados de la actividad por todo el personal de GESTLIFE .
            </p>  
            </li>
            </ul>

         <p style={styles.paragraph}>
     Por el anuncio de esta política, Las clínicas asumen voluntariamente la obligación de cumplir con los requisitos de la norma internacional ISO 9001: 2008,  que sigue los requisitos legales y de otro tipo, y trabajan constantemente en la mejora de la calidad  del sistema de gestión, aumentando su eficacia como la base para mejorar la satisfacción de los pacientes y otras partes interesadas.
            </p> 

            <h4 style={styles.subHeadingMinor}>
           TIPOS DE PROGRAMA 
            </h4>
          <p style={styles.paragraph}>
     Disponemos de todo un abanico de posibilidades para lograr su sueño de convertirse en padres. 
    GESTLIFE , le garantiza en sus programas de embarazo garantizado, conseguir su sueño en un plazo prefijado, y si no lo logra, le devolvemos el 50 % del  coste del tratamiento  médico sin preguntas (en los  programas “embarazo garantizado”).
    </p>
    <p>
    Ello le garantiza un ahorro importante, y evitar sorpresas económicas. 
    </p>
    <p>
    Tal es nuestro compromiso con ustedes:
    </p>
    
    <ol>
        <li>
    <p style={styles.paragraph}>
     Programa  sin donante de óvulos ( con óvulos propios) “ programa embarazo garantizado “
    </p>
    </li>
    <li>
    <p style={styles.paragraph}>
     Programa con donante de óvulos “ programa embarazo garantizado “
    </p>
    </li>
    <li>
    <p style={styles.paragraph}>
     Programa individual sin donante de óvulos ( óvulos propios)
    </p>
    </li>
     <li>
    <p style={styles.paragraph}>
     Programa individual con donante de óvulos 
    </p>
    </li>
    <li>
    <p style={styles.paragraph}>
     Programa individual con selección de  sexo con donante de óvulos 
    </p>
    </li>
     <li>
    <p style={styles.paragraph}>
     Trasplante pro nuclear o trasplante de uso meiótico. 
    </p>
    </li>

    </ol>

    <h4 style={styles.subHeadingMinor}>
           BUSQUE Y COMPARE
    </h4>
     <p style={styles.paragraph}>
     Recuerde al comparar  nuestros programas, con otros programas en otras clínicas (europeas o españolas) que a diferencia de éstas. Nuestros programas incluyen dentro del precio los siguientes servicios:
    </p>
    <ul>
     <li>
        <p style={styles.paragraph}>
     Recogida en el aeropuerto, y acompañamiento hasta los apartamentos
        </p>
    </li>
    <li>
        <p style={styles.paragraph}>
     Acompañamiento a la clínica
        </p>
    </li>
    <li>
        <p style={styles.paragraph}>
     Asistencia de un encargado de asistencia que habla su idioma
        </p>
    </li>
    <li>
        <p style={styles.paragraph}>
     Estancia en los apartamentos GESTLIFE en apartamento individual con todos los servicios.
        </p>
    </li>
    <li>
        <p style={styles.paragraph}>
     Desayuno, comida y cenas durante su estancia ( en los programas VIP)
        </p>
    </li>
    <li>
        <p style={styles.paragraph}>
     Regreso al aeropuerto 
        </p>
    </li>
    <li>
        <p style={styles.paragraph}>
     Asistencia en viaje durante su estancia ( programa VIP)
        </p>
    </li>
     <li>
        <p style={styles.paragraph}>
     Centro de asistencia 24 horas al día durante su estancia.
        </p>
    </li>
     <li>
        <p style={styles.paragraph}>
     Visitas turísticas a la ciudad durante su estancia. ( Programa VIP)
        </p>
    </li>
    <li>
        <p style={styles.paragraph}>
     Asistencia psicológica a cargo de psicólogo de la compañía.
        </p>
    </li>
    </ul>

        <h4 style={styles.subHeading}>
            Programa embarazo garantizado con óvulos propios
        </h4>
          <p style={styles.paragraph}>
        En  GESTLIFE  somos muy conscientes del estrés que genera  un proceso de fecundación. A ello hay que añadir el esfuerzo económico que algunas familias tienen que hacer para someterse a uno o varios ciclos sin tener la certeza de en qué ciclo van a conseguir su objetivo.
        </p>
        <p style={styles.paragraph}>
        Este programa garantiza una FIV-ICSI CON ÓVULOS PROPIOS con máximo de 4 trasferencia embrionaria, a un precio fijo y cerrado, sin tener que pagar por ellos, ya que están incluidos dentro del precio cerrado. 
        </p>
        <p style={styles.paragraph}>
        Además, si no logramos el objetivo tras 4 transferencia embrionaria, LE DEVOLVEMOS EL 50% DEL COSTE DEL TRATAMIENTO MEDICO pagado por este programa.
        </p>
        <p style={styles.paragraph}>
        Si transcurridos estos 4 intentos, usted desea abandonar, GESTLIFE  le reembolsa el 50% del precio del programa, o le ofrece la posibilidad de realizar 2 transferencias más,  pero en este caso,  perdería la garantía de reembolso del 50 %. 
        </p>
        <p style={styles.paragraph}>
        La pareja de someterá previamente a una evaluación médica antes de ser aceptada en el programa. Si es aceptada en el mismo, podrá dar comienzo al tratamiento de  FIV. Una vez se queda embarazada, y transcurren 8 semanas de gestación, el programa se dará por finalizado.
        </p>
        <p style={styles.paragraph}>
        Le garantizamos la devolución del 50% de la suma pagada por el tratamiento de reproducción asistida con  donación de ovocitos en el  caso de que no hayamos conseguido el embarazo después de las 4  transferencias de embriones,   o la posibilidad de realizar otras 2 transferencias, con la perdida de garantía de devolución. 
        </p>

    <h4 style={styles.subHeadingMinor}>
           Numero de viaje necesarios
    </h4>
     <p style={styles.paragraph}>
    En el programa EMBARAZO GARANTIZADO son necesarios:
    </p>
    <ul>
        <li>1 viaje  de aproximadamente 12 días para realizar todas las pruebas médicas, que permiten a la clínica verificar que se reúnen los requisitos del programa  y realizar la punción ovárica, y la primera transferencia embrionaria.</li>
        <li>Tantos viajes adicionales como nuevas transferencias sean precisas, hasta un máximo de 3 viajes.</li>
    </ul>

    <h4 style={styles.subHeadingMinor}>
    Requisitos por parte del varon para participar en el programa garantizado:
    </h4>
          <p style={styles.paragraph}>
            <b>
            Exámenes preliminares obligatorios:
            </b>
        </p> 
        <ol>
            <li>
            Prueba de esperma y la Criopreservación (al menos 4 viales).
            </li>
             <li>
            Cariotipo de un marido / pareja (recomendado).
            </li>
            <li>
            Análisis de sangre.
            </li>
        </ol> 

        <p style={styles.paragraph}>
            <b>
            Por parte del varón:
            </b>
        </p>            
            <ul>
                <li>
                  Debe tener 50 años o menos cuando inicie el programa  
                </li>
                <li>
                    No debe ser fumador ni tener hábitos tóxicos (alcohol. drogas, anabolizantes etc...). 
                </li>
                <li>
                   Calidad espermática: debe tener un recuento de espermatozoides móviles de más de 3 millones, con el estudio hecho en nuestro laboratorio.
                </li>
                <li>
                   Quedan excluidos los varones con OTA (oligoastenoterazoospermia) severa (menos de 5 millones de espermatozoides por mililitro en el eyaculado), astenozoosermia severa con un recuento de espermatozoides móviles de inferior a 3 millones de espermatozoides móviles u otros factores masculinos severos sin previo estudio andrológico.
                </li>
                 <li>
                   El comité médico de admisión tiene en consideración diversos factores además de la edad, como pueden ser el diagnóstico de la esterilidad, la calidad del esperma, los niveles de estradiol, presencia de quistes ováricos etc… sin la aceptación del comité médico, no se puede realizar el programa EMBARAZO GARANTIZADO.
                </li>
                 <li>
                  No padecer enfermedades congénitas, hereditarias o infecciosas transmisibles con riesgo grave para la posible descendencia, que no hayan sido valoradas por el equipo médico.
                </li>
                <li>
                 No haber omitido o falseado ningún dato de tipo médico o legal que pudiera incidir en el tratamiento o sus consecuencias.
                </li>
                <li>
                 Comprometerme/Comprometernos a notificar al centro los cambios de circunstancias personales (defunción, separación, divorcio,...).
                </li>
                 <li>
                 Obligarme/Obligarnos a comunicar los cambios de domicilio en caso de existir preembriones criopreservados.
                </li>
            </ul>
                <p style={styles.paragraph}>
            (Si no reuniese estos requisitos, debería optar por un programa individual).
        </p>    

        <p style={styles.paragraph}>
            <b>
            Requisitos por parte de la mujer para participar en el programa garantizado:
            </b>
        </p>

         <ul>
                <li>
                Debe tener como máximo 37 años (en el momento del inicio del primer tratamiento).
                </li>
                <li>
                Tener una reserva ovárica normal.
                </li>
                <li>
                No debe haber realizado más de ciclos 2 de FIV previamente en nuestro centro o en otros centros.
                </li>
                <li>
                No sufrir enfermedades crónicas que interfieran en poder llevar con éxito el embarazo.
                </li>
                 <li>
                  No debe ser fumadora.
                </li>
                 <li>
                 Si ya ha realizado anteriormente un ciclo de FIV, deberá aportar toda la documentación médica del mismo.
                </li>
                <li>
                 No observarse quistes ováricos.
                </li>
                <li>
                Debe tener un IMC (índice de masa corporal) inferior a 30. El IMC es una medida de obesidad que se calcula dividiendo el peso de la persona,   por el cuadrado de la altura (en metros).
                </li>
                 <li>
                 AMH (hormona Antimuleriana) mayor a 1,2, y FSH ( hormona folículo estimulante) menor a 10
                </li>
               <li>Deberá realizarse una ecografía de recuento folicular antral, en la que deberán contarse al menos 7 folículos antrales en los ovarios.</li>
                <li>Debe haber fácil acceso a ambos ovarios.</li>
            <li>Debe tener ambos ovarios.</li>
            <li>No pueden haber pólipos ni miomas en el útero. En el caso de que hubiesen miomas, éstos deben ser intramurales de menos de 4 centímetros, y que no afecten a la cavidad uterina.</li>
            <li>No debe existir impedimento alguno para realizar la transferencia de embriones vía transcervical.</li>
            <li>En el caso de mujeres con enfermedades crónicas (diabetes, enfermedades autoinmunes, etc.) su médico deberá autorizar la gestación antes de empezar el programa.</li>
            <li>La ausencia de hidrosalpinge.</li>
             <li>Endometrio normal y la cavidad uterina (ecografía ginecológica + histeroscopia, según la recomendación del médico).</li>
             <li>Ultrasonido ginecológico.</li>
            </ul>

        <p style={styles.paragraph}>
            (Si no reuniese estos requisitos, debería optar por un programa individual).
        </p>    

      <h4 style={styles.subHeadingMinor}>
     Que incluye el programa embarazo garantizado:
      </h4>
       <ul>
  <li>Seguimiento del tratamiento de estimulación (en los casos que se haga a distancia).</li>
  <li>Punción ovárica.</li>
  <li>Capacitación espermática.</li>
  <li>Inseminación de los ovocitos.</li>
  <li>ICSI (Microinyección espermática), si está indicado.</li>
  <li>Cultivo embrionario.</li>
  <li>Cultivo hasta estadio de blastocisto, si está indicado.</li>
  <li>Eclosión asistida, si está indicada.</li>
  <li>Transferencia embrionaria eco-guiada.</li>
  <li>Preparación endometrial para un ciclo de transferencia.</li>
  <li>Transferencia eco-guiada de los embriones.</li>

  <li>Recogida en el aeropuerto y acompañamiento hasta los apartamentos.</li>
  <li>Acompañamiento a la clínica.</li>
  <li>Entrega de un teléfono local móvil para sus llamadas (programa VIP).</li>
  <li>Asistencia de un encargado de asistencia que habla su idioma.</li>
  <li>Estancia en los apartamentos GESTLIFE en apartamento individual con todos los servicios.</li>
  <li>Desayuno, comida y cenas durante su estancia (programa VIP).</li>
  <li>Regreso al aeropuerto.</li>
  <li>Asistencia en viaje durante su estancia (programa VIP).</li>
  <li>Centro de asistencia 24 horas al día durante su estancia.</li>
  <li>Visitas turísticas a la ciudad durante su estancia (programa VIP).</li>
</ul>

 <h4 style={styles.subHeadingMinor}>
           Que no incluye:
</h4>
<ul>
  <li>Evaluación y preparación para un ciclo de Fecundación In Vitro (FIV). Pruebas diagnósticas pre Fecundación In Vitro.</li>
  <li>Cualquier medicación* de la paciente como: gonadotrofinas, progesterona, luprón, antibióticos, excepto las medicaciones anestésicas utilizadas durante la punción ovárica.</li>
  <li>No incluye los casos de Diagnóstico Genético Preimplantacional (PGD) y análisis prenatal.</li>
  <li>Banco de semen.</li>
  <li>No incluye complicaciones en el proceso del tratamiento de Fecundación In Vitro (FIV) o del embarazo. Cualquier complicación derivada del proceso de FIV, incluyendo síndrome de hiperestimulación ovárica, complicaciones del embarazo, aborto o embarazo ectópico.</li>
  <li>Prueba de embarazo en orina (cualquier kit de farmacia).</li>
  <li>Otras cirugías que no sean la punción ovárica. Ningún acto quirúrgico no relacionado con el proceso de la Fecundación In Vitro (FIV) (laparoscopia, histeroscopia, miomectomía, raspado por pérdida embrionaria, etc.).</li>
  <li>Coste directo asociado con la biopsia testicular (TESA/TESE).</li>
  <li>Cualquier otro gasto u otros servicios médicos no realizados por el equipo de la clínica donde se realice el tratamiento (sin contar el anestesista para la punción ovárica).</li>
</ul>

 <p style={styles.paragraph}>
    En el caso de que los tratamientos no hayan funcionado durante este periodo de tiempo, se les reembolsará EL 50% del precio del  tratamiento médico. De esta forma podrán afrontar otras opciones reproductivas.
 </p>    

 <h4 style={styles.subHeading}>
    Programa embarazo garantizado con ovodonación (donante de óvulos)
 </h4>
 <p style={styles.paragraph}>
    En  GESTLIFE  somos muy conscientes del estrés que genera  un proceso de fecundación. A ello hay que añadir el esfuerzo económico que algunas familias tienen que hacer para someterse a uno o varios ciclos sin tener la certeza de en qué ciclo van a conseguir su objetivo.
 </p> 
 <p style={styles.paragraph}>
  Este programa garantiza una FIV-ICSI CON OVODONACIÓN DE DONANTE con máximo de 4 trasferencia embrionaria, a un precio fijo y cerrado, sin tener que pagar por ellos, ya que están incluidos dentro del precio cerrado. 
 </p> 
 <p style={styles.paragraph}>
  Además si no logramos el objetivo tras 4 transferencia embrionaria, LE DEVOLVEMOS EL 50% DEL TRATAMIENTO MÉDICO pagado por este programa.
 </p> 
 <p style={styles.paragraph}>
    Si transcurridos estos 4 intentos, usted desea abandonar, GESTLIFE  le reembolsa el 50% del precio del  tratamiento médico, o le ofrece la posibilidad de realizar 2 transferencias más,  pero en este caso,  perdería la garantía de reembolso del 50 %. 
 </p> 
 <p style={styles.paragraph}>
  La pareja de someterá previamente a una evaluación médica antes de ser aceptada en el programa. Si es aceptada en el mismo, podrá dar comienzo al tratamiento de  FIV. Una vez se queda embarazada, y transcurren 8 semanas de gestación, el programa se dará por finalizado.
 </p> 
 <p style={styles.paragraph}>
   Le garantizamos la devolución del 50% del tratamiento médico por el programa de donación de ovocitos en el  caso de que no hayamos conseguido el embarazo después de las 4  transferencias de embriones, o la posibilidad de realizar otras 2 transferencias, con la perdida de garantía de devolución. 
 </p> 

  <h4 style={styles.subHeadingMinor}>
           Numero de viaje necesarios
</h4>
    <p style={styles.paragraph}>
    En el programa EMBARAZO GARANTIZADO son necesarios:
    </p>
    <ul>
        <li>Un viaje de aproximadamente 8 días  para realizar todas las pruebas médicas, que permiten a la clínica verificar que se reúnen los requisitos del programa  y realizar la punción ovárica, y la primera transferencia embrionaria.</li>
        <li>Tantos viajes adicionales como nuevas transferencias sean precisas, hasta un máximo de 3 viajes.</li>
    </ul>

    <h4 style={styles.subHeadingMinor}>
    Requisitos por par del varón para participar en el programa garantizado:
</h4>

  <p style={styles.paragraph}>
    Exámenes preliminares obligatorios:
    </p>
<ul>
        <li>Un viaje de aproximadamente 8 días  para realizar todas las pruebas médicas, que permiten a la clínica verificar que se reúnen los requisitos del programa  y realizar la punción ovárica, y la primera transferencia embrionaria.</li>
        <li>Tantos viajes adicionales como nuevas transferencias sean precisas, hasta un máximo de 3 viajes.</li>
    </ul>

<p style={styles.paragraph}>
     <b>
    Por parte del varón:            
            </b>
</p>   

<ul>
  <li>Debe tener 50 años o menos cuando inicie el programa.</li>
  <li>No debe ser fumador ni tener hábitos tóxicos (alcohol, drogas, anabolizantes, etc.).</li>
  <li>Calidad espermática: debe tener un recuento de espermatozoides móviles de más de 3 millones, con el estudio hecho en nuestro laboratorio.</li>
  <li>Quedan excluidos los varones con OTA (oligoastenoteratozoospermia) severa (menos de 5 millones de espermatozoides por mililitro en el eyaculado), astenozoospermia severa con un recuento de espermatozoides móviles inferior a 3 millones u otros factores masculinos severos sin previo estudio andrológico.</li>
  <li>El comité médico de admisión tiene en consideración diversos factores además de la edad, como pueden ser el diagnóstico de la esterilidad, la calidad del esperma, los niveles de estradiol, presencia de quistes ováricos, etc. Sin la aceptación del comité médico, no se puede realizar el programa EMBARAZO GARANTIZADO.</li>
  <li>No padecer enfermedades congénitas, hereditarias o infecciosas transmisibles con riesgo grave para la posible descendencia, que no hayan sido valoradas por el equipo médico.</li>
  <li>No haber omitido o falseado ningún dato de tipo médico o legal que pudiera incidir en el tratamiento o sus consecuencias.</li>
  <li>Comprometerme/Comprometernos a notificar al centro los cambios de circunstancias personales (defunción, separación, divorcio, etc.).</li>
  <li>Obligarme/Obligarnos a comunicar los cambios de domicilio en caso de existir.</li>
</ul>

<p style={styles.paragraph}>
   (Si no reuniese estos requisitos, debería optar por un programa individual).
 </p> 

<p style={styles.paragraph}>
     <b>
    Requisitos por parte de la mujer para participar en el programa garantizado:            
         </b>
</p>   

<ul>
  <li>Debe tener como máximo 37 años (en el momento del inicio del primer tratamiento).</li>
  <li>No debe haber realizado más de 2 ciclos de FIV previamente en nuestro centro o en otros centros.</li>
  <li>No sufrir enfermedades crónicas que interfieran en poder llevar con éxito el embarazo.</li>
  <li>No debe ser fumadora.</li>
  <li>Si ya ha realizado anteriormente un ciclo de FIV, deberá aportar toda la documentación médica del mismo.</li>
  <li>No observarse quistes ováricos.</li>
  <li>Debe tener un IMC (índice de masa corporal) inferior a 30. El IMC es una medida de obesidad que se calcula dividiendo el peso de la persona por el cuadrado de la altura (en metros).</li>
  <li>AMH (hormona antimuleriana) mayor a 1,2, y FSH (hormona folículo estimulante) menor a 10.</li>
  <li>No pueden haber pólipos ni miomas en el útero. En el caso de que hubiesen miomas, éstos deben ser intramurales de menos de 4 centímetros y que no afecten a la cavidad uterina.</li>
  <li>No debe existir impedimento alguno para realizar la transferencia de embriones vía transcervical.</li>
  <li>En el caso de mujeres con enfermedades crónicas (diabetes, enfermedades autoinmunes, etc.) su médico deberá autorizar la gestación antes de empezar el programa.</li>
  <li>La ausencia de hidrosálpinx.</li>
  <li>Endometrio normal y la cavidad uterina (ecografía ginecológica + histeroscopia, según la recomendación del médico).</li>
  <li>Ultrasonido ginecológico.</li>
</ul>

<p style={styles.paragraph}>
   (Si no reuniese estos requisitos, debería optar por un programa individual).
 </p> 

 <p style={styles.paragraph}>
     <b>
  Que incluye el programa embarazo garantizado con ovodonación:            
         </b>
</p>   
       
       <ul>
  <li>Donante de ovocitos (Incluye inducción de la ovulación: visitas, control médico, medicación para la donante, ecografías y análisis hormonales (E2, progesterona), punción ovárica y recuperación de ovocitos).</li>
  <li>Capacitación espermática.</li>
  <li>Inseminación de los ovocitos.</li>
  <li>ICSI (Microinyección espermática), si está indicado.</li>
  <li>Cultivo embrionario.</li>
  <li>Cultivo hasta estadio de blastocisto, si está indicado.</li>
  <li>Eclosión asistida, si está indicada.</li>
  <li>Transferencia embrionaria eco-guiada.</li>
  <li>Preparación endometrial para un ciclo de transferencia.</li>
  <li>Acompañamiento a la clínica.</li>
  <li>Entrega de un teléfono local móvil para sus llamadas (programa VIP).</li>
  <li>Asistencia de un encargado de asistencia que habla su idioma.</li>
  <li>Estancia en los apartamentos GESTLIFE en apartamento individual con todos los servicios.</li>
  <li>Desayuno, comida y cenas durante su estancia (programa VIP).</li>
  <li>Regreso al aeropuerto.</li>
  <li>Asistencia en viaje durante su estancia (programa VIP).</li>
  <li>Centro de asistencia 24 horas al día durante su estancia.</li>
  <li>Visitas turísticas a la ciudad durante su estancia (programa VIP).</li>
</ul>

<h4 style={styles.subHeadingMinor}>
           Que no incluye:
</h4>

<ul>
  <li>Evaluación y preparación para un ciclo de Fecundación In Vitro (FIV). Pruebas diagnósticas pre Fecundación In Vitro.</li>
  <li>Cualquier medicación* de la paciente como: gonadotrofinas, progesterona, luprón, antibióticos, excepto las medicaciones anestésicas utilizadas durante la punción ovárica.</li>
  <li>No incluye los casos de Diagnóstico Genético Preimplantacional (PGD) y análisis prenatal.</li>
  <li>Banco de semen.</li>
  <li>No incluye complicaciones en el proceso del tratamiento de Fecundación In Vitro (FIV) o del embarazo. Cualquier complicación derivada del proceso de FIV, incluyendo síndrome de hiperestimulación ovárica, complicaciones del embarazo, aborto o embarazo ectópico.</li>
  <li>Prueba de embarazo en orina (cualquier kit de farmacia).</li>
  <li>Otras cirugías que no sean la punción ovárica. Ningún acto quirúrgico no relacionado con el proceso de la Fecundación In Vitro (FIV) (laparoscopia, histeroscopia, miomectomía, raspado por pérdida embrionaria, etc.).</li>
  <li>Coste directo asociado con la biopsia testicular (TESA/TESE).</li>
  <li>Cualquier otro gasto u otros servicios médicos no realizados por el equipo de la clínica donde se realice el tratamiento (sin contar el anestesista para la punción ovárica).</li>
</ul>
<p style={styles.paragraph}>
   En el caso de que los tratamientos no hayan funcionado durante este periodo de tiempo, se les reembolsará EL 50% del precio del tratamiento médico. De esta forma podrán afrontar otras opciones reproductivas.
 </p> 

  <h4 style={styles.subHeading}>
    Comparativa del programa embarazo garantizado Gestlife con otras clinicas de FIV
 </h4>

 <p style={styles.paragraph}>
En GESTLIFE  le ofrecemos un paquete de fecundación in vitro con  una transferencia con embriones frescos y con 3 crio transferencias. 
 </p> 
 <p style={styles.paragraph}>
   En cualquier caso, y sin justificación necesaria, tanto el cliente como GESTLIFE  podrán rescindir el contrato con garantía de devolución del 50 % del precio del tratamiento médico ( en los programas EMBARAZO GARANTIZADO)  si tras un cuarto ciclo, no se hubiese logrado el objetivo del embarazo. Ello tiene como objetivo permitir a aquellos clientes que no deseen continuar hasta el final (por la razón que sea: estrés, etc…) poder abandonar el programa sin perdidas económicas.
 </p> 
 <p style={styles.paragraph}>
   Hay que tener en cuenta que aproximadamente el 85% de las parejas que entran en el programa van a realizar ICSI (Microinyección espermática), y el 50% van a tener embriones supernumerarios para congelar.
 </p> 
 <p style={styles.paragraph}>
   El cuadro comparativo que encontrará más abajo ha sido realizado comparando tarifas de varias de las principales clínicas en España.
 </p> 
 <p style={styles.paragraph}>
   Ha de tener en cuenta que en dichas clínicas (como en las demás), se cobra por cada ciclo de fecundación in vitro, más la técnica ICSI, la congelación de los embriones sobrantes (para posteriores transferencias), y el coste de la primera transferencia en fresco, y dos transferencias más con embriones congelados (para cada ciclo).
 </p> 

 <h4 style={styles.subHeadingMinor}>
  Programas individuales
</h4>
<p style={styles.paragraph}>
   EL PROGRAMA CICLO FIV INDIVIDUAL GESTLIFE , va destinado a las personas que desean abordar el programa de fecundación in vitro, paso a paso, con sus propios óvulos o con ovodonante, pagando solo por los servicios que se prestan, a medida que se produzcan.
 </p> 

 <p style={styles.paragraph}>
  En un ciclo, se procederá a la estimulación de la mujer o de la donante (según sea el caso), para poder obtener un número de óvulos con los cuales se generen posteriormente los embriones que serán transferidos, dependiendo del número de óvulos, de la calidad de los mismos, de la calidad de los embriones resultantes.
 </p> 

 <h4 style={styles.subHeading}>
    Programa individual con óvulos propios
 </h4>

<h4 style={styles.subHeadingMinor}>
   Que incluye el programa individual:
</h4>

<ul>
  <li>Capacitación espermática.</li>
  <li>Preparación de la paciente (no incluye medicación para estimulación).</li>
  <li>Punción ovárica.</li>
  <li>Inseminación de los ovocitos.</li>
  <li>ICSI (Microinyección espermática), si está indicado.</li>
  <li>Cultivo embrionario.</li>
  <li>Cultivo hasta estadio de blastocisto, si está indicado.</li>
  <li>Eclosión asistida, si está indicada.</li>
  <li>Transferencia embrionaria eco-guiada.</li>
  <li>Preparación endometrial para una transferencia.</li>
  <li>Transferencia eco-guiada de los embriones.</li>
</ul>

  <p style={styles.paragraph}>
 En el caso de que no lograse quedar embarazada al primer intento, podrá realizar intentos subsiguientes, abonando el coste del tratamiento por dicho concepto ,más los gastos de estancia.
 </p> 

  <p style={styles.paragraph}>
 <b>El programa  CICLO FIV INDIVIDUAL GESTLIFE  ofrece los mismos servicios de acompañamiento en  las ocasiones que se desplacen a Kiev):</b>
 </p>

<ul>
  <li>Recogida en el aeropuerto y acompañamiento hasta los apartamentos.</li>
  <li>Entrega de un teléfono móvil local para sus llamadas (programas VIP).</li>
  <li>Acompañamiento a la clínica.</li>
  <li>Asistencia de un encargado de asistencia que habla su idioma.</li>
  <li>Estancia en los apartamentos GESTLIFE en apartamento individual con todos los servicios.</li>
  <li>Desayuno, comida y cenas durante su estancia (programas VIP).</li>
  <li>Regreso al aeropuerto.</li>
  <li>Asistencia en viaje durante su estancia (programas VIP).</li>
  <li>Centro de asistencia 24 horas al día durante su estancia.</li>
  <li>Visitas turísticas durante su estancia en Kiev (en programas VIP).</li>
</ul>

<h4 style={styles.subHeadingMinor}>
   Que no incluye el programa individual:
</h4>

<ul>
  <li>Evaluación y preparación para un ciclo de Fecundación In Vitro (FIV). Pruebas diagnósticas pre Fecundación In Vitro.</li>
  <li>Cualquier medicación* de la paciente como: gonadotrofinas, progesterona, luprón, antibióticos, excepto las medicaciones anestésicas utilizadas durante la punción ovárica.</li>
  <li>No incluye los casos de Diagnóstico Genético Preimplantacional (PGD) y análisis prenatal.</li>
  <li>Banco de semen.</li>
  <li>No incluye complicaciones en el proceso del tratamiento de Fecundación In Vitro (FIV) o del embarazo. Cualquier complicación derivada del proceso de FIV, incluyendo síndrome de hiperestimulación ovárica, complicaciones del embarazo, aborto o embarazo ectópico.</li>
  <li>Prueba de embarazo en orina (cualquier kit de farmacia).</li>
  <li>Otras cirugías que no sean la punción ovárica. Ningún acto quirúrgico no relacionado con el proceso de la Fecundación In Vitro (FIV) (laparoscopia, histeroscopia, miomectomía, raspado por pérdida embrionaria, etc.).</li>
  <li>Coste directo asociado con la biopsia testicular (TESA/TESE).</li>
  <li>Cualquier otro gasto u otros servicios médicos no realizados por el equipo GESTLIFE (sin contar el anestesista para la punción ovárica).</li>
  <li>Los programas individuales no tienen garantía de reembolso.</li>
</ul>

<h4 style={styles.subHeading}>
    Programa con selección de sexo
 </h4>

  <p style={styles.paragraph}>
  Si ustedes desean seleccionar el sexo de su hijo (bien sea por razones médicas, por equilibrar su progenie, o bien sencillamente porque tienen preferencia por un sexo en concreto),  la selección de sexo está permitida en Ucrania.
 </p>
  <p style={styles.paragraph}>
  En España la selección de sexo no está permitida por la ley. Solo puede realizarse en los casos en que se puede evitar la transmisión de enfermedades genéticas ligadas al cromosoma X, como es el caso, por ejemplo, de la Hemofilia.
 </p>
  <p style={styles.paragraph}>
En cambio en Ucrania las  pruebas genéticas están ahora disponibles para explorar la causa de la infertilidad. Los factores genéticos incluyen anormalidades cromosómicas, mutaciones en un único gen y síndromes monogénicas o multifactoriales.
 </p>
  <p style={styles.paragraph}>
  Para poder realizar la selección de sexo, es necesario hacer el DGP (DIAGNÓSTICO PREIMPLANTACIONAL GENÉTICO) .
 </p>
 <p style={styles.paragraph}>
  El  DGP es el único método eficaz probado (casi 100%) para diagnosticar el sexo del niño. Si se desea una niña, sólo los embriones determinan que XX se transferirán al útero y si un hombre desea que el embrión Sea un niño, solo un embrión con la estructura cromosómica XY será transferido.
 </p>
 <p style={styles.paragraph}>
  El DGP  ofrece dos importantes ventajas:
 </p>
<ul>
    <li>Ayuda a descartar posibles anomalías cromosómicas en el embrión.</li>
    <li>Permite la selección de sexo.</li>
</ul>
 <p style={styles.paragraph}>
La selección de sexo, solo es realizable  dentro de los programas individuales, ya que implica la no utilización de los embriones del sexo no solicitado.
 </p>

<h4 style={styles.subHeadingMinor}>
   Que incluye el programa selección de sexo:
</h4>

<ul>
  <li>Capacitación espermática.</li>
  <li>Preparación y compensación de la donante de óvulos (solo en los programas con ovodonación de donante).</li>
  <li>Punción ovárica.</li>
  <li>Inseminación de los ovocitos.</li>
  <li>ICSI (Microinyección espermática), si está indicado.</li>
  <li>Cultivo embrionario.</li>
  <li>DGP con selección de sexo.</li>
  <li>Cultivo hasta estadio de blastocisto, si está indicado.</li>
  <li>Eclosión asistida, si está indicada.</li>
  <li>Transferencia embrionaria eco-guiada.</li>
  <li>Preparación endometrial para un ciclo de transferencia.</li>
  <li>Transferencia eco-guiada de los embriones.</li>
</ul>

<p style={styles.paragraph}>
El programa  SELECCIÓN DE SEXO GESTLIFE  ofrece los mismos servicios de acompañamiento en  las dos ocasiones que se desplacen a Kiev (la primera para la punción ovárica,  donación del semen,  y generación embriones,  y la segunda para la transferencia embrionaria:
 </p>

<ul>
  <li>Recogida en el aeropuerto y acompañamiento hasta los apartamentos.</li>
  <li>Acompañamiento a la clínica.</li>
  <li>Entrega de un teléfono móvil local para sus llamadas (programa VIP).</li>
  <li>Asistencia de un encargado de asistencia que habla su idioma.</li>
  <li>Estancia en los apartamentos GESTLIFE en apartamento individual con todos los servicios.</li>
  <li>Desayuno, comida y cenas durante su estancia (programa VIP).</li>
  <li>Regreso al aeropuerto.</li>
  <li>Asistencia en viaje durante su estancia (programa VIP).</li>
  <li>Centro de asistencia 24 horas al día durante su estancia.</li>
  <li>Visitas turísticas durante su estancia en Kiev (programa VIP).</li>
</ul>

<h4 style={styles.subHeadingMinor}>
Que no incluye el programa selección de sexo:
 </h4>

<ul>
  <li>Evaluación y preparación para un ciclo de Fecundación In Vitro (FIV). Pruebas diagnósticas pre Fecundación In Vitro.</li>
  <li>Cualquier medicación* de la paciente como: gonadotrofinas, progesterona, luprón, antibióticos, excepto las medicaciones anestésicas utilizadas durante la punción ovárica.</li>
  <li>No incluye los casos de Diagnóstico Genético Preimplantacional (PGD) y análisis prenatal.</li>
  <li>Banco de semen.</li>
  <li>No incluye complicaciones en el proceso del tratamiento de Fecundación In Vitro (FIV) o del embarazo. Cualquier complicación derivada del proceso de FIV, incluyendo síndrome de hiperestimulación ovárica, complicaciones del embarazo, aborto o embarazo ectópico.</li>
  <li>Prueba de embarazo en orina (cualquier kit de farmacia).</li>
  <li>Otras cirugías que no sean la punción ovárica. Ningún acto quirúrgico no relacionado con el proceso de la Fecundación In Vitro (FIV) (laparoscopia, histeroscopia, miomectomía, raspado por pérdida embrionaria, etc.).</li>
  <li>Coste directo asociado con la biopsia testicular (TESA/TESE).</li>
  <li>Cualquier otro gasto u otros servicios médicos no realizados por el equipo GESTLIFE (sin contar el anestesista para la punción ovárica).</li>
  <li>Los programas individuales no tienen garantía de reembolso.</li>
</ul>

<h4 style={styles.subHeadingMinor}>
Proceso de estimlación ovárica
 </h4>
<p style={styles.paragraph}>
El proceso de estimulación ovárica debe realizarse bajo la supervisión de la clínica donde se vaya a realizar el tratamiento de reproducción asistida.  Lo normal es que el tratamiento dure aproximadamente dos semanas.
 </p>
 <p style={styles.paragraph}>
Ustedes pueden optar por dos posibilidades:
 </p>

 <ol>
    <li>
       Iniciar el tratamiento hormonal en su ciudad de origen, bajo la supervisión de su ginecólogo local, en conexión con el ginecólogo de la clínica en Kiev.  De este modo, deberán viajar cuando falten aproximadamente  5 días  para fecha prevista para la ovulación.  En ese caso el viaje durará aproximadamente 12 días. Deben ser conscientes que este sistema conlleva ciertas dosis de estrés añadido,  con la toma de un avión durante el proceso de estimulación, factores que siempre pueden  interferir en  el proceso. 
    </li>
    <li>
       Realizar el proceso de estimulación íntegramente en el país de destino, realizando el proceso de estimulación íntegramente en Kiev.  Por ello, el viaje tendrá una duración de entre 20 y 25 días. 
    </li>
 </ol>

 <h4 style={styles.subHeading}>
    Programa con o sin donante de óvulos
 </h4>

  <p style={styles.paragraph}>
Casos en que es precisa la intervención de una donante de óvulos ajena a la pareja.
 </p>
  <p style={styles.paragraph}>
Aquellas parejas en las que siendo el marido fértil, la mujer no tiene ovarios, pero tiene el útero normal, precisarán una donante de óvulos. También será necesaria la donante de óvulos en los casos de las mujeres con ovarios que no funcionan, o aquellas mujeres con conocimiento de enfermedades hereditarias que desean evitar la transmisión de dicha enfermedad a sus hijos, teniendo hijos sanos. También pueden precisar una donante de óvulos mujeres que han sido sometidas a radioterapia o quimioterapia. A veces, se llega a la conclusión de que es precisa la donante de óvulos tras múltiples inseminaciones o varias FIV fallidas.
 </p>
  <p style={styles.paragraph}>
En las primeras visitas, se determinará cada caso, y la necesidad o no de una donante. En esa visita, el hombre donará su semen, para lo que tendrá que haber observado una serie de reglas en los días inmediatamente anteriores, así como un periodo de abstinencia de 4 a 7 días. La muestra de semen será analizada y congelada para su uso posterior. La mujer empezará el tratamiento para preparar el endometrio con tratamiento vía oral o con parches, siguiendo las instrucciones de nuestro equipo médico. Si la pareja reside lejos, podrá hacer el seguimiento en un médico de su ciudad, enviando los resultados a nuestro equipo médico. Será preciso un segundo desplazamiento a nuestro centro, para la transferencia de los embriones, que se habrán generado microinyectando los espermatozoides del varón, en los óvulos de la donante. En este segundo viaje si no lo desea, el varón no precisa desplazarse.
 </p>
  <p style={styles.paragraph}>
Las donantes son seleccionadas entre estudiantes universitarias mayores de edad. En el proceso de selección se analiza el historial clínico de la donante, la exploración ginecológica, análisis de sangre y ecografía. Se realiza un estudio citológico, bacteriológico de la vagina-cuello del útero, y de sangre para Sida, sífilis, hepatitis B y C, thalasamia y hemofilia. Se les hace también cariotipo, para descartar alteraciones cromosómicas y/o translocaciones. En el caso de que todos los resultados sean normales la donante es aceptada. Ello implica que solo un 25 % de las donantes son aceptadas. En el caso de no ser aceptadas se les informa del motivo, así como de los resultados obtenidos. Se les informa que el único destino de los óvulos es el tratamiento de la esterilidad femenina. La donación es anónima, por lo que las partes nunca se conocerán, ni podrán obtener datos de la otra parte.
 </p>
  <p style={styles.paragraph}>
La donación es voluntaria y gratuita. El consentimiento de la donante se hace por escrito. La gratuidad de la donación no impide que se compense económicamente a la donante por las molestias sufridas y gastos ocasionados (desplazamientos, ausencias en el trabajo etc...). Es importante resaltar que por Ley, la donante no tendrá derecho alguno sobre el hijo conseguido con sus óvulos.
 </p>
  <p style={styles.paragraph}>
Proceso de donación de óvulos por la donante. Una vez la donante es admitida como tal, firma el consentimiento, e inicia un tratamiento hormonal (con inyecciones diarias) bajo control de los médicos. Este tratamiento tiene como objetivo estimular la maduración de los óvulos en los ovarios. La fecha de inicio del tratamiento viene fijada por el inicio del ciclo menstrual de la donante. Durante el proceso, se realiza un seguimiento médico para verificar en que momento están maduros los óvulos. Para la extracción, la donante será sedada suavemente, permaneciendo dormida unos 20 minutos, durante los cuales se hará la punción ovárica.
 </p>
  <p style={styles.paragraph}>
Acto seguido, se descongela el semen del varón, y se procede a la microinyección de un espermatozoide en cada uno de los óvulos obtenidos de la donante. Entre las 16 y las 20 horas siguientes, se observa al microscopio si los óvulos han sido fecundados. Paralelamente, el ginecólogo ya ha realizado el control endometrial de la mujer que va a recibir los embriones, y confirmado que está preparada debidamente, se realiza la transferencia de los embriones, lo que suele suceder tres días después de la extracción de los óvulos. El resto de embriones conseguidos, y que no se implantaran en este ciclo, pueden ser congelados. Si sucediese que la receptora aún no está suficientemente preparada, se pueden congelar también.
 </p>

<p style={styles.paragraph}>
            <b>
           El Embryoscope
            </b>
        </p>       

        <p style={styles.paragraph}>
Para evaluar la calidad de los embriones se utiliza principalmente el método morfológico. Los embriones son evaluados de acuerdo con los siguientes criterios - el número de blastómeros, la igualdad y la fragmentación de los blastómeros (interrupción de los blastómeros normales). Sin embargo, este es el método más antiguo de la evaluación de la calidad del embrión, pero no es perfecto - es subjetivo (depende del nivel de experiencia del embriólogo), el embrión es extremadamente variable en su desarrollo - embrión antiestético a los 2 días (una especie de "patito feo") puede convertirse en un perfecto estado de salud y un bebé muy lindo. Actualmente, un nuevo método para evaluar la calidad de los embriones es el  embryoscopy. Su principio es el siguiente: cada 10-20 minutos que se toma una imagen del embrión en las 7 capas, utilizando un programa de ordenador las imágenes se superponen una sobre otra y obtener un vídeo de corta duración - "Resumen" de cada embrión. El uso de un programa informático especial ayuda a identificar los parámetros clave del desarrollo embrionario:
 </p> 

<p style={styles.paragraph}>
            <b>
           ICSI
            </b>
        </p>   
        <p style={styles.paragraph}>
La palabra "ICSI" (ICSI) se deriva de la reducción de las primeras letras de la frase Inglés intracitoplasmática de espermatozoides de inyección, que se traduce literalmente como "la introducción de esperma en el citoplasma del ovocito." Este procedimiento se realiza por lo general en los casos de formas graves de infertilidad masculina en la que la capacidad de fertilización de los espermatozoides se reduce significativamente.
</p>
<p>
Las indicaciones para el método ICSI son los siguientes:
</p>
 
 <ul>
  <li>De la primera división.</li>
  <li>El comienzo de la segunda división (aparición del tercer blastómero).</li>
  <li>El final de la segunda división (aparición del cuarto blastómero).</li>
  <li>Sincronicidad de la segunda división (el período entre la aparición del tercer y cuarto blastómero).</li>
  <li>El comienzo de la tercera división (aparición del quinto blastómero).</li>
  <li>El final de la tercera división (aparición de ocho blastómeros).</li>
  <li>El comienzo de la compactación del embrión.</li>
  <li>La aparición de la cavidad en el embrión (comienzo de blastulación).</li>
</ul>

<p style={styles.paragraph}>
            <b>
           Técnica de la ICSI
            </b>
        </p>  

        <p style={styles.paragraph}>
La palabra "ICSI" (ICSI) se deriva de la reducción de las primeras letras de la frase Inglés intracitoplasmática de espermatozoides de inyección, que se traduce literalmente como "la introducción de esperma en el citoplasma del ovocito." Este procedimiento se realiza por lo general en los casos de formas graves de infertilidad masculina en la que la capacidad de fertilización de los espermatozoides se reduce significativamente.
</p>

<p style={styles.paragraph}>
            <b>
           Los resultados de ICSI
            </b>
        </p> 

             <p style={styles.paragraph}>
 La frecuencia de la fertilización con ICSI puede variar de 30 a 80%. No hay ninguna garantía de que cada ovulo  después del procedimiento se  convierta en embrión. La falta de fertilizar el  óvulo y la división puede estar relacionado con la dificultad del procedimiento (daño del óvulo), así como la calidad de los gametos. Por ejemplo, cuando la selección de esperma para ICSI aparentemente puede ser de buena calidad (motilidad y estructura), puede contener anormalidades cromosómicas. La calidad de los óvulos también tiene un impacto en los resultados de la ICSI y todo el programa in vitro. En general, la tasa de embarazo después de la ICSI no difiere de la de la media durante el programa clásico in vitro y es 40-45%.
</p> 

<p style={styles.paragraph}>
            <b>
          IMSI
            </b>
        </p> 

             <p style={styles.paragraph}>
IMSI. Infertilidad masculina
Este método de tratamiento de la infertilidad masculina ha sido creado recientemente. Las primeras publicaciones aparecieron en 1999 y la eficacia clínica se demostró en 2004 por el grupo de científicos de Israel, dirigido por el profesor B. Bartoov. El punto principal del método es la selección preliminar de espermatozoides morfológicamente normales antes del procedimiento ICSI, y la abreviatura IMSI (inyección intracitoplasmática de espermatozoides morfológicamente seleccionados) se traduce inyección de esperma intracitoplasmática como morfológicamente seleccionados.
</p> 
   <p style={styles.paragraph}>
 En el  procedimiento ICSI de espermatozoides se selecciona con una lupa de 200-400 veces, lo que permite una estimación aproximada de las características morfológicas de los espermatozoides.
</p> 
   <p style={styles.paragraph}>
El mérito del grupo de Profesor Bartoov está en el hecho de que han demostrado una relación entre la morfología de los espermatozoides fina y una eficacia del tratamiento. Sin embargo, para tal selección, es necesario lograr un aumento de 6600 veces sin perturbar la vida de los espermatozoides. Se puso de manifiesto que, en tales condiciones de  gran aumento, casi igual a Microscopía Electrónica, es posible detectar los cambios sutiles en la estructura del espermatozoide, y después de la selección del espermatozoide más normal es posible lograr en ciertos grupos de pacientes una alta frecuencia de  embarazo y la baja frecuencia de aborto espontáneo.
</p> 

<h4 style={styles.subHeading}>
    Transplante pro nuclear o de uso meiotico
 </h4>

<h4 style={styles.subHeadingMinor}>
    Preguntas frecuentes
 </h4>

  <p style={styles.paragraph}>
<b>Cuando es recomendable el ICSI?</b><br />
Para pacientes con 2 o más intentos fallidos de FIV.
Para los pacientes con infertilidad masculina y alto nivel de teratozoospermia, con cada  vez mayor  cantidad de formas de espermatozoides anormales
</p> 

  <p style={styles.paragraph}>
<b>¿Por qué mis embriones pueden tener patología cromosómica?</b><br />
Alrededor del 70% de los embriones (tanto en el embarazo natural y después del tratamiento ART) no llegan a hasta el nacimiento del bebé, debido a un  aborto involuntario durante el  embarazo o a la interrupción de proceso de implantación. La razón principal es la presencia de  anomalías cromosómicas (llamados "aneuploidía"), causadas por la pérdida o la presencia de un cromosoma extra o su parte.
</p> 

  <p style={styles.paragraph}>
<b>¿Cuáles son los métodos de diagnóstico preimplantacional?</b><br />
Hoy en día los métodos siguientes se utilizan para la detección de aneuploidía en el diagnóstico de preimplantación:
FISH-análisis (cribado de aneuploidías de embriones con cromosomas 9-12 en pacientes que son portadores de los reordenamientos cromosómicos);
La hibridación genómica comparativa (cribado de aneuploidías de embriones para todos los cromosomas en los pacientes portadores de  reordenamientos cromosómicos en casos de múltiples intentos fallidos de fecundación in vitro y aborto involuntario habitual con cariotipo normal de embriones).

</p> 

 <p style={styles.paragraph}>
<b>¿Qué es la hibridación genómica comparativa?</b><br />
La hibridación genómica comparada (CGH) - es un método moderno de genética molecular que pueden diagnosticar la aneuploidía cromosómica y microestructural de  reordenamientos de forma simultánea en todos los cromosomas.
</p> 
 <p style={styles.paragraph}>
<b>¿Qué es el  CGH?</b><br />
El CGH es un método  mil veces más sensible que los métodos citogenéticas estándar:
<ul>
    <li>revela alteraciones que son invisibles en el cariotipo de rutina;</li>
    <li>permite hacer evaluación de todos los cromosomas de forma simultánea;</li>
    <li>proporciona una clara identificación y caracterización cuantitativa de la anomalía.</li>
</ul>
</p> 

 <p style={styles.paragraph}>
<b>¿Cómo se pueden investigar mis embriones?</b> <br />
La clínica  lleva a cabo la investigación de los elastómeros y las células de trophoblastos:
</p> 

<ul>
    <li>Investigación de blastómeros- las células del embrión en el día 3 de desarrollo. El estudio caracteriza el embrión, pero no excluye la posibilidad de mosaicismo (cuando las células embrionarias pueden tener un conjunto diferente cromosómica).</li>
    <li>Investigación de las células trophoblastos - células que forman la capa exterior del embrión. El estudio describe el embrión incluyendo la posibilidad de mosaicismo. Sin embargo, el análisis se realiza en el día 5 del desarrollo del embrión, lo que requiere su congelación en el período de estudio (1-3 días) y posterior utilización en los ciclos congelados de ART (tecnología de reproducción asistida) . La elección de la táctica de diagnóstico se determina individualmente en cada caso basado en la historia de la infertilidad, el estado de salud de la madre, embriones y su número.</li>
    <li>proporciona una clara identificación y caracterización cuantitativa de la anomalía.</li>
    <li>Aumentar el número de ciclos de FIV con éxito.</li>
  <li>Reducir el número de embarazos múltiples (mediante la transferencia de un menor número de embriones pero cualitativos).</li>
  <li>Reducir la incidencia de aborto espontáneo o involuntario del embarazo.</li>
</ul>

<p style={styles.paragraph}>
<b>¿Y si no hay un  embrión "normal”...?</b> <br />
Hay alguna posibilidad de que ningún embrión sea lo suficientemente bueno para su transferencia y se debe definir para cada caso individual  por el médico. A continuación, el médico decidirá el régimen adicional de tratamiento. Por favor, tenga en cuenta que clínica en ningún caso llevará a cabo la transferencia de embriones  si existe aneuploidía.
</p> 

<p style={styles.paragraph}>
<b>Resultados falsos</b> <br />
Se establece que el riesgo de falsos resultados después de CGH de diagnóstico es inferior a 1%. Sin embargo, se recomienda la realización de un diagnóstico prenatal más temprano en el término del embarazo para obtener resultados precisos.
</p> 

<p style={styles.paragraph}>
<b>Características del embarazo después del diagnóstico de preimplantación</b> <br />
El Diagnóstico genético preimplantacional no da garantías absolutas para un embarazo exitoso, incluso después de la detección de todos los cromosomas, ya que puede verse comprometido por el estado inmunitario o patología no diagnosticada. En general, el embarazo después del diagnóstico preimplantacional  puede tener los mismos factores de riesgo que el embarazo natural. Mientras tanto, miles de niños de todo el mundo han nacido con el uso de diagnóstico de preimplantación.
</p> 
<p>
Le damos la bienvenida. Solo tiene que llamarnos, y nos ocuparemos de todo. Organizamos su viaje, su estancia, las visitas a la clínica, etc…  para que su estancia en Kiev sea  un placer, que lleva al logro de sus sueños.  
</p>

        </div>
        </div>

        {/* Formulario a la derecha, sin envoltorio extra ni sticky
        <div style={styles.formColumn}>
          <FormStyle1 />
        </div> */}
      </div>
    </div>
  </>
  );
};

export default FivSpainText;

// --- Estilos para la versión de escritorio ---
const styles = {
  container: {
    backgroundColor: 'white',
    padding: '2rem',
    paddingTop: '3rem',
    paddingBottom: '3rem',
    fontFamily: 'Arial, sans-serif', 
    paddingLeft: '4rem',
    paddingRight: '4rem',
  },
  contentWrapper: {
    display: 'grid',
    gridTemplateColumns: '1fr', // Por defecto, una columna para móviles
    gap: '4rem', 
    maxWidth: '1200px', 
    margin: '0 auto', 
    // La media query para desktop se simula con JS debajo
    // Idealmente, esto iría en CSS externo o con una librería CSS-in-JS.
    '@media (min-width: 1024px)': { 
      gridTemplateColumns: '2fr 1fr', 
    },
  },
  mainContent: {
    marginBottom: '2rem', // Mantener espacio para móviles/tablets
    '@media (min-width: 1024px)': {
      marginBottom: '0', // Eliminar el margen si hay dos columnas
    },
  },
  mainHeading: {
    fontSize: '2.8rem', 
    fontWeight: 'bold',
    color: '#ec4899', 
    lineHeight: '1.2',
    marginBottom: '1.5rem', 
  },
  subHeading: {
    fontSize: '1.8rem', 
    fontWeight: '700', 
    color: '#f472b6', 
    marginTop: '2.5rem', 
    marginBottom: '1.5rem', 
    borderBottom: '2px solid #f9a8d4', 
    paddingBottom: '0.5rem',
  },
  subHeadingMinor: { 
    fontSize: '1.3rem', 
    fontWeight: '600', 
    color: '#f472b6', 
    marginTop: '2rem',
    marginBottom: '1rem',
  },
  textBlock: {
    color: '#4b5563',
    lineHeight: '1.7', 
    fontSize: '1.05rem', 
    marginTop: '1.5rem',
  },
  paragraph: {
    marginBottom: '1rem', 
  },
  highlightedParagraph: {
    fontWeight: '700', 
    color: '#1f2937', 
    textDecoration: 'underline',
    textDecorationColor: '#f9a8d4', 
    marginBottom: '1.2rem', 
    fontSize: '1.1rem', 
  },
  formColumn: {
    // Ya no necesita position: 'relative' si el formulario no es sticky
    // El formulario FormStyle1 controlará sus propios estilos internos
  },
  // Eliminamos el objeto stickyForm, ya no es necesario
};
